import { ref, computed } from 'vue'

export function useTablePagination(tableData: Array<any>) {
  const filtered = ref(tableData)
  //const filtered = ref(JSON.parse(JSON.stringify(tableData)));

  const rowCount = 20
  const currPage = ref(1)

  const displayData = computed(() => {
    const startIndex = (currPage.value - 1) * rowCount
    const endIndex = startIndex + rowCount
    return filtered.value.slice(startIndex, endIndex)
  })

  const theLastPage = computed(() => {
    return Math.ceil(filtered.value.length / rowCount)
  })

  function previousPage() {
    //currPage.value = Math.max([currPage.value-1, 1]);
    if (currPage.value > 1) {
      currPage.value--
    }
  }

  function nextPage() {
    //currPage.value = Math.max([currPage.value-1, 1]);
    if (currPage.value < theLastPage.value) {
      currPage.value++
    }
  }

  function firstPage() {
    currPage.value = 1
  }

  function lastPage() {
    currPage.value = theLastPage.value
  }

  return { currPage, displayData, theLastPage, previousPage, nextPage, firstPage, lastPage }
}
